<template>
    <BreadCrumb PageTitle="Ajouter l'historique" />
    <AddHistorique />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddHistorique from "@/components/Historique/AddHistorique.vue";

export default defineComponent({
    name: "AddHistoriquePage",
    components: {
        BreadCrumb,
        AddHistorique,
    },
});
</script>